import Notification, { type NotificationOptions } from "@rio-cloud/rio-uikit/Notification"
import type {
    EmbedNotificationVariant,
    EmbedShowNotificationPayload
} from "@/components/TransportExecution/EventActions"

const notificationMethods: Record<
    EmbedNotificationVariant,
    (message: string, options?: NotificationOptions) => unknown
> = {
    default: Notification.default,
    info: Notification.info,
    success: Notification.success,
    warning: Notification.warning,
    error: Notification.error,
}

const isEmbedNotificationVariant = (variant: unknown): variant is EmbedNotificationVariant =>
    typeof variant === "string" && variant in notificationMethods

const isEmbedShowNotificationPayload = (payload: unknown): payload is EmbedShowNotificationPayload => {
    if (!payload || typeof payload !== "object") {
        return false
    }

    const candidate = payload as Record<string, unknown>

    return typeof candidate.message === "string" && isEmbedNotificationVariant(candidate.variant)
}

const makeNotificationOptions = (payload: EmbedShowNotificationPayload): NotificationOptions => ({
    ...(typeof payload.title === "string" ? { title: payload.title } : {}),
    ...(typeof payload.timeout === "number" && Number.isFinite(payload.timeout) ? { timeout: payload.timeout } : {}),
    ...(typeof payload.closeButton === "boolean" ? { closeButton: payload.closeButton } : {}),
    ...(typeof payload.closeOnClick === "boolean" ? { closeOnClick: payload.closeOnClick } : {}),
    ...(typeof payload.hideProgressBar === "boolean" ? { hideProgressBar: payload.hideProgressBar } : {}),
})

export const showEmbedNotification = (payload: unknown) => {
    if (!isEmbedShowNotificationPayload(payload)) {
        return
    }

    notificationMethods[payload.variant](payload.message, makeNotificationOptions(payload))
}
